import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

export const getInfoUser = createAsyncThunk("User/getInfoUser", async () => {
  try {
    const response = await http.get(`/api/v1/auth/getUser`);
    
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
});

// export const getUserShop = createAsyncThunk(
//   "User/getUserShop",
//   async ({ currentPage, pageSize }) => {
//     try {
//       const response = await http.get(
//         `/auth/api/v1/admin/get-shops?page=${currentPage}&size=${pageSize}`
//       );
//       return response.data;
//     } catch (error) {
//       throw new Error("Có lỗi xảy ra trong quá trình kết nối");
//     }
//   }
// );


const userAPI = {
  getUserShops: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = "",
      status = "",
      sort_by = "created_at",
      sort_order = "desc",
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(status !== "" && { status }),
    });

    return http.get(`/api/v1/auth/admin/get-shops?${queryParams}`);
  },
  
  updateProfile: (dataInfo) => http.put(`/api/v1/auth/update-profile`, dataInfo),
  changePassword: (dataInfo) => http.put(`/api/v1/auth/update-password`, dataInfo),
};


// Helper functions for handling API responses
export const userShopHelpers = {

  // Extract paginated list from API response
  extractUserShopList: (response) => {
    if (response.data && response.success) {
      const data = response.data;
      return {
        userShops: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url,
        },
      };
    }
    throw new Error(response.data?.message || "Unknown error occurred");
  },

};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 401:
            throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403:
            throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404:
            throw new Error("Không tìm thấy khách hàng");
          case 422:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        // Network error
        throw new Error("Không thể kết nối đến server");
      } else {
        // Other error
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

// Wrapped API functions with error handling
export const userAPIWithErrorHandling = {
  getUserShops: withErrorHandling(userAPI.getUserShops),
  updateProfile: withErrorHandling(userAPI.updateProfile),
  changePassword: withErrorHandling(userAPI.changePassword),
};

export default userAPI;
